module.exports = __webpack_public_path__ + "img/thumb-down.f301480a.svg";